module.exports = __webpack_public_path__ + "media/assets/icons/kasai_icon-34a1dc9f153e1bed22fe8a6f522722f1.svg";